<template>
  <div>
    <!-- Header -->
    <div class="row align-items-center">
      <div class="border-0 mb-4">
        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
          <h3 class="fw-bold mb-0">Qrupu dəyiş</h3>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="card-body">
      <form @submit.prevent="updateMessageTemplate">
        <!-- Input fields -->
        <div class="row g-3 align-items-center">
          <div class="row g-3 align-items-center">
          <div class="col-md-6">
            <label for="name" class="form-label">Adı</label>
            <input type="text" v-model="nmsgtemplate.Name" v-validate="{ required: true }" name="name" id="name" class="form-control" required="">
            <span class="inputError">{{ errors.first('name') }}</span>
          </div>

          <div class="col-md-6">
            <label for="PhoneNumbersFromFile" class="form-label">Fayl* əlavə edin
            </label>
            <input type="file"  name="PhoneNumbersFromFile" id="PhoneNumbersFromFile" class="form-control" @change="onFileChanged($event)">
            <span>* Fayl txt formatda olmalıdır
            </span>
            <span class="inputError">{{ errors.first('PhoneNumbersFromFile') }}</span>
          </div>

          <!-- Template text -->
          <div class="w-100 templateText">
            <label for="PhoneNumbersFromText" class="form-label">Nömrələri daxil edin
            </label>
            <br/>
            <textarea class="w-100 h-100 form-control" v-model="nmsgtemplate.PhoneNumbersFromText" name="PhoneNumbersFromText" id="PhoneNumbersFromText"></textarea>
            <span class="inputError">{{ errors.first('PhoneNumbersFromText') }}</span>
          </div>
        </div>
        </div>

        <!-- Buttons -->
        <div class="d-flex justify-content-between buttonsDiv">
          <button type="submit" class="btn btn-primary mt-4" :disabled="loading">Yaddaşa yaz</button>
          <!-- <button type="button" class="btn btn-danger mt-4 text-light" @click.prevent="triggerDeleteModal">Ləğv et</button> -->
        </div>
      </form>
    </div>

    <DeleteModal v-if="showDeleteModal" @closeDeleteModal="showDeleteModal = false" :text="modalText" :deletingAPI="deletingAPI" :objectId="nmsgtemplate.id"/>
  </div>
</template>

<script>
import jwtInterceptor from '../../../jwt.interceptor'
import user from '../../../store/user'
import DeleteModal from '../DeleteModal.vue'

export default {
  name: 'UpdateMessageTemplates',
  components: {
    DeleteModal
  },
  data() {
    return {
      loading: false,
      showDeleteModal: false,
      partners: [],
      modalText: {
        object: 'Group',
        header: 'Groupun ləğv edilməsi',
        question: 'Groupu ləğv edilməsinə əminsinizmi?'
      },
      deletingAPI: '/SmsGroups',
      nmsgtemplate: {
        Name: '',
        PhoneNumbersFromFile: '',
        PhoneNumbersFromText: ''
      },
    }
  },
  methods: {
    onFileChanged(e){
      this.nmsgtemplate.PhoneNumbersFromFile = e.target.files[0];
    },
    triggerDeleteModal() {
      this.showDeleteModal = true
    },
    async updateMessageTemplate() {
      this.loading = true;
      this.nmsgtemplate.name = this.nmsgtemplate.Name;
      
      const validForm = await this.isFormValid()
      if (validForm) {
        jwtInterceptor.put(this.$store.getters.getUrl + "/SmsGroups/"+this.nmsgtemplate.id, this.nmsgtemplate, { headers:{'Content-Type': 'multipart/form-data'}}).then(response => {
          if (response.data.isError === null) {
            this.$toast.success("Group uğurla dəyişdirildi!", {
              position: "top-right"
            })
            this.loading = false
            this.$router.go(-1);
          }
          else {
            this.$toast.error("Bir xəta baş verdi. Bir daha sınayın!", {
              position: "top-right"
            });
            this.loading = false
          }
        }).catch(() => {
          this.$toast.error('Bir xəta baş verdi.', {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Xanalar düzgün doldurulmayıb. Bir daha xanaları yoxlayın!", {
          position: "top-right"
        })
        this.loading = false
      }
      this.loading = false
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  created() {
    this.nmsgtemplate = user.getters.getTemplateUpdate
    this.nmsgtemplate.Name = this.nmsgtemplate.name;
    this.nmsgtemplate.PhoneNumbersFromText = this.nmsgtemplate.phones.join('\n')
  }
}
</script>

<style>
.buttonsDiv {
  width: 20%
}

.templateText {
  height: 150px;
  margin-bottom: 2rem;
}

.justify-content-custom {
  justify-content: space-between;
}

@media screen and (max-width: 881px) {
  .buttonsDiv {
    width: 100%
  }
}

@media screen and (max-width: 615px) {
  .justify-content-custom {
    justify-content: space-around !important;
  }
}
</style>